import React from "react";
import {Grid} from "@material-ui/core";
import {GRPCSelfGeneratedAPIReference} from 'grpc-docs';
import {useEntity} from "@backstage/plugin-catalog-react";
import {SchemaEntity} from "../types";

const DefinitionContent = () => {
  const {entity} = useEntity<SchemaEntity>();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <GRPCSelfGeneratedAPIReference definition={entity.spec.definition || ''}/>
      </Grid>
    </Grid>
  );
};

export default DefinitionContent;
